<template>
  <div class="slider accent">
    <div class="slide-track accent" :style="`width: calc(300px * ${companies.length});`">
      <div
        v-for="(company, index) in companies"
        :key="index"
        class="slide d-flex justify-center align-center"
        style="max-width: 300px; width: 300px"
      >
        <div style="width: 300px">
          <v-img style="width: 300px" v-if="!!company.profile_image" :src="`${host}${company.profile_image}`" :alt="company.nombre_empresa"></v-img>
          <div v-else class="text-center font-weight-light headline">{{ company.nombre_empresa }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  props: {
    companies: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      host: config.host,
    }
  },
  mounted() {
    const style = document.createElement("style");
    style.type = "text/css";
    const keyFrames = `
      @keyframes scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(calc(-300px * ${this.companies.length /
          1.6}))}
      }
    `;
    style.innerHTML = keyFrames;
    document.getElementsByTagName("head")[0].appendChild(style);
  },
  methods: {
    initials(nombre) {
      const nombreEmpresa = nombre;
      const nombreSplit = nombreEmpresa.split(" ");
      if (nombreSplit.length === 1) return nombreEmpresa[0].toUpperCase();
      else
        return `${nombreEmpresa[0].toUpperCase()}${nombreEmpresa[1].toUpperCase()}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin white-gradient {
  background: linear-gradient(
    to right,
    #f6f7fb 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

$animationSpeed: 40s;

// Animation
// @keyframes scroll {
//   0% { transform: translateX(0); }
//   100% { transform: translateX(calc(-300px * var(--total-companies-mid)))}
// }

// Styling
.slider {
  background: #f6f7fb;
  // box-shadow: 0 10px 20px -5px rgba(0, 0, 0, .125);
  height: 150px;
  margin: auto;
  overflow: hidden;
  position: relative;

  &::before,
  &::after {
    @include white-gradient;
    content: "";
    height: 150px;
    position: absolute;
    width: 150px;
    z-index: 2;
  }

  &::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
  }

  &::before {
    left: 0;
    top: 0;
  }

  .slide-track {
    animation: scroll $animationSpeed linear infinite;
    display: flex;
  }

  .slide {
    height: 150px;
    width: 300px;
  }
}
</style>